import { render, staticRenderFns } from "./rb.vue?vue&type=template&id=4a844b55&scoped=true&"
import script from "./rb.vue?vue&type=script&lang=js&"
export * from "./rb.vue?vue&type=script&lang=js&"
import style0 from "./rb.vue?vue&type=style&index=0&id=4a844b55&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a844b55",
  null
  
)

export default component.exports